import {
    createContext,
    Dispatch,
    FC,
    PropsWithChildren,
    ReactElement,
    SetStateAction,
    useContext,
    useMemo,
    useState,
} from 'react'
import type { LocalMessage } from 'stream-chat'

interface EditingMessageContextValue {
    editingMessage: LocalMessage | null
    setEditingMessage: Dispatch<SetStateAction<LocalMessage | null>>
}

const EditingMessageContext = createContext<EditingMessageContextValue | null>(null)

export const EditingMessageProvider: FC<PropsWithChildren> = ({ children }): ReactElement => {
    const [editingMessage, setEditingMessage] = useState<LocalMessage | null>(null)

    const value = useMemo((): EditingMessageContextValue => ({
        editingMessage,
        setEditingMessage,
    }), [editingMessage])

    return (
        <EditingMessageContext.Provider value={value}>
            {children}
        </EditingMessageContext.Provider>
    )
}

export const useEditingMessage = (): EditingMessageContextValue => {
    const context = useContext(EditingMessageContext)

    if (! context) {
        throw new Error('useEditingMessage must be used within an EditingMessageProvider')
    }

    return context
}
